export enum MicrophoneAccessType {
  UNKNOWN = 'UNKNOWN',
  ACCESS_GRANTED = 'ACCESS_GRANTED',
  ERROR = 'ERROR',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
}

export type BrowserState = {
  microphoneAccess: MicrophoneAccessType;
  tries: number;
  showMicrophoneAccessModal: boolean;
  isOnline: boolean;
};
